//import { css } from "@emotion/react"
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { AddOrUpdateCart } from "../../ShoppingCart/AddOrUpdateCart";

// ListView - Qty
export type ProductBrowserListItemQtyProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserListItemQty: React.FC<
	ProductBrowserListItemQtyProps
> = (props) => {
	return <AddOrUpdateCart product={props.product} />;
};
